import { Component, Output, OnInit, EventEmitter, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  AnalyticsService,
  CertificateListService,
  DateFormatService,
  NotificationService,
  WalletService,
  ProfileService,
  BalanceService,
  NotificationKeys,
  PaymentStatus,
  Processors,
  ResponseStatus,
  Services,
  captchaKeys,
  StorageKeys,
  URLS,
  RecoveryStatuses,
  TimeZones,
  Locales,
  Units,
  ErrorCodes,
  ProcessStepsModalKeys,
  Events,
  UserTypes,
  CountryCodes,
} from "@core";
import { differenceInCalendarDays } from "date-fns";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { ActivatedRoute, Router } from "@angular/router";
import { CurrencyPipe } from "@angular/common";
import { TicketCategories } from "src/app/core/config/ticket-category.config";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { BrowserStorageKeys } from "src/app/core/config/browser-storage-keys.config";
import { candidateNumberValidator } from "src/app/shared/validators/candidate-number.validator";
import { candidateExamTypeValidator } from "src/app/shared/validators/candidate-examtype.validator";
import { CaptchaService } from "src/app/core/services/captcha/captcha.service";
import { TranslateService } from "@ngx-translate/core";
import { pageRoutes } from "src/app/core/config/page-routes.config";
import { API_Statuses } from "src/app/core/config/api-response.config";
import { ExamCountrySetupComponent } from "src/app/shared/helpers/global/exam-country-setup/exam-country-setup.component";

@Component({
  selector: "app-provision",
  templateUrl: "./provision.component.html",
  styleUrls: ["./provision.component.less"],
  standalone: false,
})
export class ProvisionComponent implements OnInit {
  shareView = false;
  isloading = false;
  isVisibleMiddle = false;
  isOkLoading = false;
  accessing_id: string = "";
  isError = false;
  modalBtn = false;
  modalFooter = false;
  isNotifying = false;
  otpModal = false;
  isVerifying = false;
  submittingOtp = false;
  errorTable: any[] = [];
  accessFormDisplay: boolean = true;
  previewCertificate: boolean = false;
  viewSrc: any = null;
  certificateFace: string = "";
  isImageLoading: boolean = true;
  isDisableCheckbox: boolean = true;
  notifyModal?: NzModalRef;
  chargeNotificationModal?: NzModalRef;
  userInformationModal: boolean = false;
  autocomplete = "off";
  currency_unit_rate: any;
  payment_currency: any;
  ticketCategory: string = TicketCategories.Certificate;
  termsAndConditions: any;
  candidateInformation: any;
  loading: boolean = false;
  topUp: boolean = false;
  paymentStep = 0;
  actions: string = NotificationKeys.ACCESS;
  processStepsModal: boolean = false;

  checked: boolean = false;
  indeterminate = false;
  listOfData: any[] = [];
  accessCertificate: any[] = [];
  listOfCurrentPageData: any[] = [];
  certificationSelection: any[] = [];
  setOfCheckedId = new Set<number>();

  isVisible: boolean = false;
  isActive: boolean = true;
  error = "";
  shareEmail = "";
  errorStatus: boolean = false;
  accessingForm!: FormGroup;
  otpFormGroup!: FormGroup;
  tableLoading: boolean = false;
  termsConditionsModal: boolean = false;
  recoverExamNoModal: boolean = false;
  viewRecoveredCandidateModal: boolean = false;
  userInformationVerification: boolean = false;
  examCountrySetupModal: boolean = false;
  @ViewChild(ExamCountrySetupComponent) examCountrySetup!: ExamCountrySetupComponent;
  examDiets: any = new Array();
  retrievalList: any[] = [];
  unsuccessfulRetrievals: any[] = [];
  successfulRetrievals: any[] = [];
  filteredRetrievals: any[] = [];
  recoveryModalRadios: any[] = [];
  selectedCategory: any = "";
  pendingRetrievalList: any[] = [];
  failedRetrievalList: any[] = [];
  successful = true;
  availableExamDiets: any;
  user: any;
  accessCost: number = 0;
  recaptchaAction = captchaKeys.ACCESS_CERTIFICATE;

  //PAGINATION
  viewCertmodal: boolean = false;
  certSide: boolean = true;
  certLoading: boolean = false;
  showBalance: boolean = true;
  accessFormData: any;

  privateCandidateYear: string = "";
  pcExamTitle: string = "";
  selectedCountryName: string = "";
  today = new Date("2021-01-01");
  unitBalance!: number;
  countries: any;
  pageRoutes = pageRoutes;
  services = Services;
  userTypes = UserTypes;

  @Output() closeModal = new EventEmitter<string>();
  enableTermsConditionsAgreeButton: boolean = false;

  Year: number;
  dietYears: any[] = [];
  nzFilterOption = (): boolean => true;
  selectedValue = null;
  userInformationWindowStep = 0;

  paymentModal: boolean = false;
  walletCreditModal: boolean = false;
  changeOfNameModal: boolean = false;
  message: any = false;
  isCandidateNoRecoveryAvailable: boolean = true;
  serviceCharge: any;

  constructor(
    private wallet: WalletService,
    private walletBalance: BalanceService,
    private fb: FormBuilder,
    private certificateService: CertificateListService,
    private notify: NotificationService,
    private dateConfig: DateFormatService,
    private modal: NzModalService,
    private router: Router,
    private profileSrv: ProfileService,
    private route: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
    private storageService: StorageService,
    private recaptcha: CaptchaService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
  ) {
    this.countries = this.certificateService.getLocalStorageCountry("WAEC");
    this.termsAndConditions =
      this.certificateService?.getLocalStorageTermsandConditions();
    this.Year = 0;
    this.user = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!)
  }

  //PROVISSION FORM
  get year(): AbstractControl {
    return this.accessingForm.controls.year;
  }
  get dob(): AbstractControl {
    return this.accessingForm.controls.dob;
  }
  get candidate_no(): AbstractControl {
    return this.accessingForm.controls.candidate_no;
  }

  get confirm_candidate_no(): AbstractControl {
    return this.accessingForm.controls.confirm_candidate_no;
  }
  get validData(): AbstractControl {
    return this.accessingForm.controls.validData;
  }
  get exam_type(): AbstractControl {
    return this.accessingForm.controls.exam_type;
  }
  get country(): AbstractControl {
    return this.accessingForm.controls.country;
  }
  //OTP FORM
  get otp(): AbstractControl {
    return this.otpFormGroup.controls.otp;
  }

  ngOnInit(): void {
    this.buildAccessForm();
    this.buildOtpForm();
    this.isCandidateNoRecoveryAvailable = this.profileSrv.isNigerianExamCountryUser();
    this.listExamDiets();
    this.checkTmpInputs();
    this.getServiceCost();
    this.confirmPayment();
    this.onEnableCheckbox();
    this.getCurrencyUnitRate();
  }

  buildAccessForm() {
    this.accessingForm = this.fb.group(
      { 
        year: [null, [Validators.required]],
        dob: [null],
        validData: [false, [Validators.required]],
        exam_type: [null, [Validators.required]],
        country: [null, [Validators.required]],
        candidate_no: [null, [
          Validators.required,
          candidateNumberValidator(() => this.accessingForm?.controls?.country?.value)
        ]],
        confirm_candidate_no: [
          null,
          [
            Validators.required,
            Validators.minLength(6),
            ProvisionComponent.passwordEqual,
          ],
        ],
      },
      { validators: [candidateExamTypeValidator()] },
    );
  }

  buildOtpForm() {
    this.otpFormGroup = this.fb.group({
      otp: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  getCurrencyUnitRate() {
    let userObject = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    this.currency_unit_rate = userObject.wallet.currency_unit_rate;
    this.payment_currency = userObject.wallet.payment_currency;
  }

  openRecoveredCandidateNumberModal() {
    this.viewRecoveredCandidateModal = true;
  }

  updateRecoveryModalRadios() {
    this.recoveryModalRadios = [
      {
        label: RecoveryStatuses.SUCCESSFUL_LABEL,
        value: RecoveryStatuses.SUCCESSFUL,
        display: this.successfulRetrievals.length > 0,
      },
      {
        label: RecoveryStatuses.PENDING,
        value: RecoveryStatuses.PENDING,
        display: this.pendingRetrievalList.length > 0,
      },
      {
        label: RecoveryStatuses.FAILED,
        value: RecoveryStatuses.FAILED,
        display: this.failedRetrievalList.length > 0,
      },
    ];
  }

  async patchUserCountryOnForm() {
    const countries = await JSON.parse(localStorage.getItem('countryProfiles')!);
    const user = await JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    const userCountry = await countries.find((country: any) => country?.id === user?.exam_country_profile_id);
    this.accessingForm.controls.country.patchValue(userCountry?.country_code);
  }

  requestCertPortal() {
    this.analytics.outboundClick('request_cert_portal');
    window.open(URLS.REQUEST_CERT_PORTAL);
  }

  setCandidateNo(value: any) {
    this.accessingForm.controls.candidate_no.markAsDirty();
    this.accessingForm.controls.candidate_no.updateValueAndValidity();
    this.accessingForm.controls.candidate_no.setValue(value.candidate_number);

    this.accessingForm.controls.confirm_candidate_no.markAsDirty();
    this.accessingForm.controls.confirm_candidate_no.updateValueAndValidity();
    this.accessingForm.controls.confirm_candidate_no.setValue(
      value.candidate_number,
    );

    this.accessingForm.controls.exam_type.markAsDirty();
    this.accessingForm.controls.exam_type.updateValueAndValidity();
    this.accessingForm.controls.exam_type.setValue(value.exam_name);

    this.accessingForm.controls.year.markAsDirty();
    this.accessingForm.controls.year.updateValueAndValidity();
    this.accessingForm.controls.year.setValue(value.exam_year);

    this.accessingForm.controls.dob.markAsDirty();
    this.accessingForm.controls.dob.updateValueAndValidity();
    this.accessingForm.controls.dob.setValue(
      new Date(new Date(value.dob).toLocaleString(Locales.EN, { timeZone: TimeZones.UTC })),
    );

    this.onEnableCheckbox();
    this.viewRecoveredCandidateModal = false;
  }

  //checks if the candidate number and confirm candidate number field values match.
  static passwordEqual(control: FormControl): { equal: boolean } | null {
    if (!control || !control.parent) {
      return null;
    }
    if (control.value !== control.parent.get("candidate_no")!.value) {
      return { equal: true };
    }
    return null;
  }

  copynpaste() {
    //prevents the pasting and dragging into the confirm candidates number input field
    return false;
  }

  onEnableCheckbox() {
    this.accessingForm.controls.confirm_candidate_no.updateValueAndValidity();
    if (
      this.accessingForm.controls.candidate_no.value != null &&
      this.accessingForm.controls.confirm_candidate_no != null &&
      this.accessingForm.controls.exam_type.value != null &&
      this.accessingForm.controls.year.value != null &&
      this.accessingForm.controls.candidate_no.valid &&
      this.accessingForm.controls.confirm_candidate_no.valid &&
      this.accessingForm.controls.exam_type.valid &&
      this.accessingForm.controls.year.valid &&
      !this.accessingForm.hasError("candidateNumberExamTypeMismatch") &&
      this.accessingForm.controls.candidate_no.value ===
        this.accessingForm.controls.confirm_candidate_no.value
    ) {
      this.isDisableCheckbox = false;
    } else {
      this.isDisableCheckbox = true;
    }
  }

  checkFormValidity(): boolean {
    if (this.accessingForm?.valid && this.checked == true) {
      return false;
    }
    return true;
  }

  checkTmpInputs() {
    // this.examCountrySetupModal = false;
    let data: any = this.profileSrv.getInputDetailsTemporarily();
    if (data?.year) {
      this.chooseDiet(data.year);
      this.accessingForm?.patchValue({
        year: data.year,
        dob: data.dob,
        exam_type: data.exam_type,
        country: data.country,
        candidate_no: data.candidate_no,
      });
    }
  }

  choosenDiet() {
    this.accessingForm.controls.exam_type.markAsDirty();
    this.accessingForm.controls.exam_type.updateValueAndValidity();
  }

  handleOk(): void {
    this.loading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isOkLoading = false;
    }, 1000);
  }

  handleCancel(): void {
    this.shareView = false;
  }

  chooseDiet(value: any) {
    let year = value?.value ? value?.value : value;
    this.Year = year;
    this.availableExamDiets = this.examDiets?.filter(
      (i: any) => i.year == year,
    )[0]?.diets;

    this.accessingForm?.patchValue({
      exam_type: null,
    });
  }

  listExamDiets(closeModal?: boolean) {
    this.patchUserCountryOnForm();
    if(closeModal) { 
      this.certificateService.getExaminationDiet().then((res: any) => {
        this.certificateService.setExamDiets(JSON.stringify(res?.data));
        this.examDiets = res?.data;
        this.examCountrySetupModal = false;
        this.sortDiets();
      });
    } else {
      const examDiet = JSON.parse(this.certificateService.getExamDiets()!);
  
      if (!examDiet) {
        this.certificateService.getExaminationDiet().then((res: any) => {
          this.certificateService.setExamDiets(JSON.stringify(res?.data));
          this.examDiets = res?.data;
          this.sortDiets();
        });
      } else {
        this.examDiets = examDiet;
        this.sortDiets();
      }
    }
  }

  sortDiets() {
    this.dietYears = [];
    this.examDiets?.map((i: any) => this.dietYears?.push(i.year));
    this.dietYears?.sort((a, b) => b - a);
    this.checkTmpInputs();
  }

  disabledDate_of_Birth = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;

  showNotify(): void {
    this.notifyModal = this.modal.confirm({
      nzTitle: this.translate.instant('PROVISIONING.CERTIFICATES.REQUEST_CONSENT'),
      nzContent: this.translate.instant(
        "PROVISIONING.CERTIFICATES.PROCEED_CONFIRMATION",
      ),
      nzMaskClosable: false,
      nzOkText: this.translate.instant("GENERAL.YES"),
      nzOnOk: () =>
        setTimeout(() => {
          this.notifiyOwner();
        }, 500),
      nzCancelText: this.translate.instant("GENERAL.NO"),
    });
  }

  getServiceCost() {
    let services = JSON.parse(this.certificateService.getServiceCharges()!);
    if (!services) {
      this.wallet
        .walletServices()
        .then((res) => {
          this.certificateService.setServiceCharges(
            JSON.stringify(res?.data?.data),
          );
          this.setAccessCharge(res?.data?.data);
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      this.setAccessCharge(services);
    }
  }

  setAccessCharge(data: any) {
    let services = data?.filter(
      (i: any) => i.item?.toLowerCase() == Services.ACCESSING,
    )[0];
    this.accessCost = services?.service_values?.filter(
      (i: any) => i.value_text?.toLowerCase() == Units.UNIT,
    )[0]?.value;
  }

  confirmInformation() {
    this.modal.closeAll();
    this.processStepsModal = false;
    this.candidateInformation = this.accessingForm.value;
    this.serviceCharge = this.currencyPipe.transform(
      this.currency_unit_rate * this.accessCost!,
      this.payment_currency,
    );
    this.profileSrv.clearInputDetailsTemporarily();
    this.profileSrv.storeInputDetailsTemporarily(this.accessingForm.value);
    this.processStepsModal = true;
  }

  closeConfirmInformation() {
    this.userInformationModal = false;
  }

  cancelOtpModal(): void {
    this.otpModal = false;
    this.otpFormGroup.reset();
  }

  enableTermsConditions(value: any) {
    this.enableTermsConditionsAgreeButton = value ? false : true;
  }

  notifiyOwner() {
    this.loading = true;
    let body: any = {
      provision_id: this.accessing_id,
    };
    this.certificateService
      .notifyUser(body)
      .then((res) => {
        this.loading = false;
        if (res?.status == ResponseStatus.ERROR) {
          this.notify.error("", res?.error, NotificationKeys.ACCESS);
          return;
        }
        this.accessFormData = res?.data;
        this.notify.info("", res?.message, NotificationKeys.ACCESS);
      })
      .catch((err) => {
        this.loading = false;
        console.warn(err);
      });
  }

  submitOtp() {
    this.loading = true;
    this.otp.markAsDirty();
    this.otp.updateValueAndValidity();

    if (this.otp.invalid) {
      this.analytics.formSubmitted('access_otp', 'invalid');
      this.loading = false;
      return;
    }
    this.analytics.formSubmitted('access_otp', 'valid');
    let body: any = {
      id: this.accessing_id,
      otp: this.otp.value,
    };
    this.certificateService
      .validateOtp(body)
      .then((res) => {
        this.loading = false;
        if (res?.status == ResponseStatus.FAILED) {
          this.analytics.otpSendFailed();
          this.notify.info("", res?.message, NotificationKeys.ACCESS);
          return;
        }
        this.analytics.otpVerified();
        this.router.navigate([pageRoutes.certificates.certificates], {
          queryParams: { id: this.accessing_id },
        });
        this.accessingForm.reset();
        this.accessFormData = null;
        this.cancelOtpModal();
        this.notify.success("", res?.message, NotificationKeys.ACCESS);
        this.clearAndStoreInputDetailsTemporarilyLogic();
      })
      .catch((err) => {
        this.loading = false;
        this.notify.error("", err, NotificationKeys.ACCESS);
        this.accessing_id = "";
      });
  }

  cancelMeansofIdentificationModal() {
    this.userInformationVerification = false;
  }

  cancelPaymentOptionsModal() {
    this.paymentModal = false;
  }

  cancelmodalContentbillingpayment() {
    this.walletCreditModal = false;
  }

  fetchingCertificate: boolean = false;
  certificateFetched: boolean = false;

  async fetchCertificate() {
    this.analytics.formSubmitted('access_certificate', 'valid');
    this.accessing_id = "";
    const captchaToken = await this.recaptcha.executeAction(
      this.recaptchaAction,
    );
    this.loading = true;
    let body: any = {
      year: this.year.value,
      candidate_number: this.candidate_no.value,
      country: this.country.value,
      dob: this.dob.value ? this.dateConfig.formatDate(this.dob.value) : null,
      exam_type: this.exam_type.value,
      captchaToken: captchaToken,
      captchaAction: this.recaptchaAction,
    };

    this.fetchingCertificate = true;
    this.certificateService
      .access(body)
      .then((res) => {
        this.fetchingCertificate = false;
        this.loading = false;
        this.accessing_id = res?.data;
        if (res?.status === ResponseStatus.FAILED && res?.subCode === null) {
          this.analytics.retrievalFailed(Services.ACCESSING);
          this.walletBalance.getbalance();
          this.notify.info("", res?.message, NotificationKeys.ACCESS);
          return;
        }
        this.analytics.retrievalSuccess(Services.ACCESSING);
        this.notify.success("", res?.message, NotificationKeys.ACCESS);
        this.walletBalance.getbalance();
        this.accessing_id = String(res?.data?.id ? res?.data?.id : res.data);
      })
      .catch((err: any) => {
        this.loading = false;
        this.fetchingCertificate = false;
        this.walletBalance.getbalance();
        console.error(err?.error?.message);
      });
  }

  async accessingFormSubmit() {
    if (this.accessing_id) {
      this.profileSrv.clearInputDetailsTemporarily();
      this.accessingForm.reset();
      this.router.navigate([pageRoutes.certificates.certificates], {
        queryParams: { id: this.accessing_id },
      });
      return;
    }
    if (this.fetchingCertificate) {
      return;
    }
    const captchaToken = await this.recaptcha.executeAction(
      this.recaptchaAction,
    );
    this.loading = true;
    this.processStepsModal = false;
    this.cancelMeansofIdentificationModal();
    let body: any = {
      year: this.year.value,
      candidate_number: this.candidate_no.value,
      country: this.country.value,
      dob: this.dob.value ? this.dateConfig.formatDate(this.dob.value) : null,
      exam_type: this.exam_type.value,
      captchaToken: captchaToken,
      captchaAction: this.recaptchaAction,
    };
    this.certificateService
      .access(body)
      .then((res) => {
        this.loading = false;
        if (res?.status === ResponseStatus.FAILED && res?.subCode == null) {
          this.analytics.retrievalFailed(Services.ACCESSING);
          this.dismissModal();
          this.loading = false;
          this.walletBalance.getbalance();
          this.notify.info("", res?.message, NotificationKeys.ACCESS);
          this.message = res.message;
          this.router.navigateByUrl(this.router.url.split("?")[0]);
          return;
        }

        if (res?.subCode === 601 && res?.status === ResponseStatus.FAILED) {
          this.analytics.otpSendFailed();
          this.accessing_id = String(res?.data?.id ? res?.data?.id : res.data);
          this.message = res.message;
          this.otpModal = true;
          return;
        }

        this.analytics.retrievalSuccess(Services.ACCESSING);
        this.notify.success("", res?.message, NotificationKeys.ACCESS);
        this.walletBalance.getbalance();
        this.accessing_id = String(res?.data?.id ? res?.data?.id : res.data);
        this.message = res?.message;
        this.profileSrv.clearInputDetailsTemporarily();
        this.router.navigate([pageRoutes.certificates.certificates], {
          queryParams: { id: this.accessing_id },
        });
        this.message = res.message;
        this.accessingForm.reset();
      })
      .catch((err) => {
        this.loading = false;
        this.walletBalance.getbalance();
        this.accessErrorBlock(err);
      });
  }

  accessErrorBlock(err: any) {
    if (err.status === API_Statuses[402] && err?.error?.data == ErrorCodes.FUND_WALLET) {
      this.clearAndStoreInputDetailsTemporarilyLogic();
      setTimeout(() => {
        this.candidateInformation = this.accessingForm.value;
        this.serviceCharge = this.currencyPipe.transform(
          this.currency_unit_rate * this.accessCost!,
          this.payment_currency,
        );
        this.topUp = true;
        this.paymentStep = 1;
        this.processStepsModal = true;
      }, 1000);
    }
    if (err.status === API_Statuses[403] && err?.error?.data == ErrorCodes.PHONE_VERIFICATION) {
      //Phone verification
      this.requestVerification(ErrorCodes.PHONE_VERIFICATION);
      return;
    }
    if (err.status === API_Statuses[403] && err?.error?.data == ErrorCodes.BIODATA) {
      //Biodata
      this.requestVerification(ErrorCodes.BIODATA);
    }
    if (err.status === API_Statuses[403] && err?.error?.data == ErrorCodes.IDENTITY_VERIFICATION) {
      this.requestVerification(ErrorCodes.IDENTITY_VERIFICATION);
    }
  }

  requestVerification(data: string) {
    if (data === ErrorCodes.PHONE_VERIFICATION) {
      this.actions = ProcessStepsModalKeys.ACCESS;
      this.userInformationWindowStep = 0;
      this.userInformationVerification = true;
    }
    if (data === ErrorCodes.BIODATA) {
      this.actions = ProcessStepsModalKeys.ACCESS;
      this.userInformationWindowStep = 1;
      this.userInformationVerification = true;
    }
    if (data === ErrorCodes.IDENTITY_VERIFICATION) {
      this.actions = ProcessStepsModalKeys.VIEW_CERTIFICATE;
      this.userInformationWindowStep = 2;
      this.userInformationVerification = true;
    }
  }

  clearAndStoreInputDetailsTemporarilyLogic() {
    this.profileSrv.clearInputDetailsTemporarily();
    this.profileSrv.storeInputDetailsTemporarily(this.accessingForm.value);
  }

  initiateWallet(value: any) {
    this.paymentModal = false;
    if (value == Services.WALLET) {
      this.accessingFormSubmit();
    } else {
      this.paymentModal = false;
    }
  }

  initiateFundingWallet() {
    this.paymentModal = true;
    this.walletCreditModal = false;
  }

  confirmPayment() {
    let processor = null;
    let reference = null;
    this.route.queryParams.subscribe((params) => {
      processor = params?.processor;
      reference = params?.reference;
      if (!processor && !reference) {
        return;
      }
      if (
        processor == Processors.FLUTTERWAVE &&
        params?.status != PaymentStatus.SUCCESSFUL
      ) {
        this.analytics.transactionCompleted('failed', Services.ACCESSING);
        this.notify.error(
          "",
          this.translate.instant("GENERAL.YOUR_PAYMENT_TRANSACTION") +
            params.status +
            "!",
          NotificationKeys.BILLING,
        );
        this.router.navigateByUrl(this.router.url.split("?")[0]);
        return;
      }
      let body = {
        processor: processor,
        trxref: reference,
        reference: reference,
        transaction_id: params?.transaction_id
          ? params?.transaction_id
          : params?.tx_ref,
      };
      this.certificateService
        .confirmPayment(body)
        .then((res) => {
          this.loading = false;
          if (res.status === ResponseStatus.FAILED) {
            this.analytics.transactionCompleted('failed', Services.ACCESSING);
            this.notify.error("", res.message, NotificationKeys.BILLING);
            this.router.navigateByUrl(this.router.url.split("?")[0]);
            return;
          }
          this.analytics.transactionCompleted('success', Services.ACCESSING);
          this.accessingFormSubmit();
        })
        .catch((err) => {
          console.warn(err);
          this.router.navigateByUrl(this.router.url.split("?")[0]);
        });
    });
  }

  submit(): void {
    this.userInformationModal = false;
    this.isloading = true;
    this.error = "";
    this.country.markAsDirty();
    this.year.markAsDirty();
    this.candidate_no.markAsDirty();
    this.exam_type.markAsDirty();
    this.validData.markAsDirty();

    this.country.updateValueAndValidity();
    this.year.updateValueAndValidity();
    this.candidate_no.updateValueAndValidity();
    this.exam_type.updateValueAndValidity();
    this.validData.updateValueAndValidity();

    if (
      this.country.invalid ||
      this.year.invalid ||
      this.candidate_no.invalid ||
      this.validData.invalid
    ) {
      this.analytics.formSubmitted('access_certificate', 'invalid');
      this.loading = false;
      return;
    }
    this.analytics.formSubmitted('access_certificate', 'valid');

    this.profileSrv.clearInputDetailsTemporarily();
    this.profileSrv.storeInputDetailsTemporarily(this.accessingForm.value);
    this.checkBalanceInitiatePayment();
  }

  checkButton(): void {
    this.openTermsConditions();
  }

  retrieveButton(): void {
    if (!this.isCandidateNoRecoveryAvailable) return;
    this.recoverExamNoModal = true;
  }

  checkStorage() {
    if (localStorage.getItem(StorageKeys.NAME_CHANGED) == null) {
      return true;
    } else {
      return false;
    }
  }

  agreeToTerms() {
    this.privateCandidateYear = this.year.value;
    this.pcExamTitle = this.exam_type.value;
    this.accessingForm.controls["validData"].setValue(true);
    this.termsConditionsModal = false;
    this.checked = true;
  }

  agreeToRecoverTerms() {
    if (!this.enableTermsConditionsAgreeButton) {
      this.loading = false;
      return;
    }
    this.termsConditionsModal = false;
    this.enableTermsConditionsAgreeButton = false;
    this.router.navigate([pageRoutes.access.recovery]);
  }

  proceedToRecoveryPage() {
    this.analytics.outboundClick('recover_candidate_number');
    this.router.navigate([pageRoutes.access.recovery]);
  }

  openExamNoRecoveryPage() {
    this.analytics.outboundClick('recover_candidate_number');
    this.recoverExamNoModal = false;
    this.router.navigateByUrl(pageRoutes.access.recovery);
  }

  openTermsConditions() {
    this.country.markAsDirty();
    this.year.markAsDirty();
    this.candidate_no.markAsDirty();
    this.exam_type.markAsDirty();

    this.country.updateValueAndValidity();
    this.year.updateValueAndValidity();
    this.candidate_no.updateValueAndValidity();
    this.exam_type.updateValueAndValidity();

    if (
      this.country.invalid ||
      this.year.invalid ||
      this.candidate_no.invalid
    ) {
      this.loading = false;
      return;
    }

    if (this.accessingForm.controls.validData.value == true) {
      this.termsConditionsModal = true;
    } else {
      this.termsConditionsModal = false;
      this.checked = false;
    }
  }

  dismissModal() {
    this.accessingForm.controls["validData"].setValue(false);
    this.termsConditionsModal = false;
    this.checked = false;
  }

  dismissRecoveryModal() {
    this.recoverExamNoModal = false;
  }

  closeRecoveredCandidateModal(event: any) {
    this.viewRecoveredCandidateModal = false;
    if (event == Events.RECOVER) {
      this.recoverExamNoModal = true;
    }
  }

  async checkBalanceInitiatePayment() {
    const wallet = await this.storageService.getLocalStorageItem(
      BrowserStorageKeys.token,
    )?.wallet;
    const balance = await wallet?.unit_balance;

    if (balance <= 0) {
      this.paymentModal = true;
    } else {
      this.accessingFormSubmit();
    }
  }

  closeProcessStepsModal(event: any) {
    this.processStepsModal = false;
    this.topUp = false;
    this.paymentStep = 0;
    this.termsConditionsModal = false;
    if (!event) {
      this.checked = false;
    }
  }

  closeExamCountrySetupModal() {
    this.examCountrySetup?.modalRef?.close();
    this.isCandidateNoRecoveryAvailable = this.profileSrv.isNigerianExamCountryUser();
    this.listExamDiets(true);
  }

}
